import { ContractorResourceTypeEnum } from '@vatos-pas/common';

export const CAPACITY_FIELD_MAP: Partial<
  Record<ContractorResourceTypeEnum, string>
> = {
  [ContractorResourceTypeEnum.Hanger]: 'hangerCapacity',
  [ContractorResourceTypeEnum.Finisher]: 'finisherCapacity',
  [ContractorResourceTypeEnum.Sprayer]: 'sprayerCapacity',
  [ContractorResourceTypeEnum.Paint]: 'paintCapacity',
  [ContractorResourceTypeEnum.Trim]: 'trimCapacity',
  [ContractorResourceTypeEnum.Bumper]: 'bumperCapacity',
};
